import axios from '@/libs/api.request'
// 预约提交评论
export const subEvaluateAppointment = data => {
  return axios.request({
    url: '/evaluate/appointment/save',
    data,
    method: 'POST'
  })
}

// 材料提交评论
export const subEvaluateMaterial = data => {
  return axios.request({
    url: '/evaluate/material/save',
    data,
    method: 'POST'
  })
}
